"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FindPlaceFromTextCacheToJSON = exports.FindPlaceFromTextCacheFromJSONTyped = exports.FindPlaceFromTextCacheFromJSON = void 0;
function FindPlaceFromTextCacheFromJSON(json) {
    return FindPlaceFromTextCacheFromJSONTyped(json, false);
}
exports.FindPlaceFromTextCacheFromJSON = FindPlaceFromTextCacheFromJSON;
function FindPlaceFromTextCacheFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'expiresAt': json['expiresAt'],
        'formattedAddress': json['formattedAddress'],
        'findPlaceFromTextResponse': json['findPlaceFromTextResponse'],
    };
}
exports.FindPlaceFromTextCacheFromJSONTyped = FindPlaceFromTextCacheFromJSONTyped;
function FindPlaceFromTextCacheToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'expiresAt': value.expiresAt,
        'formattedAddress': value.formattedAddress,
        'findPlaceFromTextResponse': value.findPlaceFromTextResponse,
    };
}
exports.FindPlaceFromTextCacheToJSON = FindPlaceFromTextCacheToJSON;
